import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Grid, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { ListContainer, FlexGrowGrid, TMGrid } from '../../styles/styles';

interface CardListProps {
  actions?: React.ReactNodeArray;
  cards: React.ReactNodeArray;
  /**
   * TODO: Describe filters prop here.
   */
  filters?: React.ReactNodeArray;
  onScroll: () => void;
  title?: string | React.ReactNode;
  showCount?: boolean;
  hideReport?: boolean;
  topMarginAdjustment?: string;
  filtersFullRow?: boolean;
}

const CardList: React.FC<CardListProps> = ({
  actions = [],
  cards,
  filters = [],
  onScroll,
  title,
  showCount = true,
  hideReport = false,
  topMarginAdjustment = '0',
  filtersFullRow = true,
}) => {
  return (
    <ListContainer>
      {hideReport ? null : (
        <Grid container>
          <Grid item xs={12} sm={filters.length === 0 ? 6 : 3}>
            {typeof title === 'string' ? (
              <Typography variant='h5'>
                {title}{' '}
                {title && showCount && cards.length > 0
                  ? `(${cards.length})`
                  : ''}
              </Typography>
            ) : (
              title
            )}
          </Grid>

          <Grid
            container
            item
            xs={12}
            sm={filtersFullRow ? 12 : filters?.length === 0 ? 6 : 9}
            justify={filters ? 'space-between' : 'flex-end'}
            spacing={2}
          >
            <TMGrid
              item
              xs={12}
              sm={actions?.length > 0 ? 8 : 12}
              tma={topMarginAdjustment}
            >
              <FlexGrowGrid container spacing={2} justify='flex-end'>
                {filters.map((filter, index) => (
                  <Grid
                    key={filter + '_' + index + '_' + Math.random()}
                    item
                    xs={12}
                    sm={filters.length > 1 ? 'auto' : 6}
                  >
                    {filter}
                  </Grid>
                ))}
              </FlexGrowGrid>
            </TMGrid>

            {actions && (
              <Grid item xs={12} sm='auto'>
                {actions}
              </Grid>
            )}
          </Grid>
        </Grid>
      )}
      <br />

      <InfiniteScroll
        dataLength={cards.length}
        next={onScroll}
        hasMore={true}
        loader={<SkeletonCard />}
      >
        {cards}
      </InfiniteScroll>
    </ListContainer>
  );
};

export default CardList;

const SkeletonCard: React.FC = () => {
  return (
    <Grid item xs={12}>
      <Skeleton variant='rect' height={80} />
    </Grid>
  );
};
